export const DRAGGABLE_TYPE = 'DragLabelDraggable'
